import React from 'react'
import { CampaignDetailsProps } from './types'
import CampaignDetails from './CampaignDetails'

const CampaignDetailsContainer: React.FC<CampaignDetailsProps> = ({ publicView }) => (
  <CampaignDetails publicView={publicView} />
)

export default CampaignDetailsContainer
